import React, { useEffect, useState } from "react";

type PaymentData = Record<string, string | null>;

const SuccessfulPayment: React.FC = () => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentData>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const data: PaymentData = {};
    params.forEach((value, key) => {
      data[key] = value;
    });
    setPaymentInfo(data);
  }, []);

  return (
    <div style={{ padding: 24, fontFamily: "sans-serif" }}>
      <h1>Payment Callback Info</h1>
      {Object.keys(paymentInfo).length === 0 ? (
        <p>No payment info received.</p>
      ) : (
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: 8 }}>Key</th>
              <th style={{ border: "1px solid #ddd", padding: 8 }}>Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(paymentInfo).map(([key, value]) => (
              <tr key={key}>
                <td style={{ border: "1px solid #ddd", padding: 8 }}>{key}</td>
                <td style={{ border: "1px solid #ddd", padding: 8 }}>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p style={{ marginTop: 16 }}>
        You can now show a success/failure message or redirect the user elsewhere.
      </p>
    </div>
  );
};

export default SuccessfulPayment;
